angular.module("moteur/composants/popup/OpPopupSuppressionFiche.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("moteur/composants/popup/OpPopupSuppressionFiche.html",
    "<op-popup-action-metier title=\"Supprimer\" action-module=\"{{$moduleNom}}\" ecran-verification=\"{{$ecranVerificationSuppression}}\" no-formulaire></op-popup-action-metier>");
}]);
